<template>
  <v-flex>
    <v-layout row wrap fluid>
      <v-flex xs12>
        <h2 class="primary--text pb-2">Permissions</h2>
        <p>Choose permissions available to each team</p>
      </v-flex>
      <div id="permissions-fixed-content">
        <div id="permissions-legend">
          <ul>
            <li> <v-icon color="green" style="width:30px; margin-right:5px">check</v-icon>Visible</li>
            <li> <v-icon color="error" style="width:30px; margin-right:5px">clear</v-icon>Hidden</li>
            <li> <v-icon color="green" class="letter" style="width:30px; margin-right:5px">R</v-icon>Read Only</li>
            <li> <v-icon color="green" class="letter" style="width:30px; margin-right:5px">W</v-icon>Writable</li>
          </ul>
        </div>
        <table id="permissions-users">
          <tr v-for="(team, teamNo) in teams" :key="teamNo">
            <td  class="text-truncate">{{team.displayName}}</td>
          </tr>
        </table>
      </div>
      <v-flex
        style="width: calc(100% - 180px); display: block !important;"
        :class="{'tabs-shift-right': $vuetify.breakpoint.smAndDown}">
        <v-tabs
          show-arrows
          color="white"
          slider-color="primary"
          :class="{'sub-tabs-full-width': $vuetify.breakpoint.smAndDown}">
          <v-tab ripple v-for="item in items" :key="item.name">{{ item.name }}</v-tab>
          <v-tab-item v-for="item in items" :key="item.name + '-content'">
            <v-divider></v-divider>
            <v-container fluid class="pa-0 ma-0">
              <v-layout row wrap>
                <v-flex xs12 px-0 pt-4>
                  <component :is="item.component" :data="permissionData" :caseType="caseType" :teams="teams"/>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import Loading from "@/components/shared/Loading.vue"
import CaseConfigPermissionFeatures from "@/components/cases/case-config/Permissions/CaseConfigPermissionFeatures.vue"
import CaseConfigPermissionFieldsets from "@/components/cases/case-config/Permissions/CaseConfigPermissionFieldsets.vue"
import CaseConfigPermissionData from "@/components/cases/case-config/Permissions/CaseConfigPermissionData.vue"
import CaseConfigPermissionTasks from "@/components/cases/case-config/Permissions/CaseConfigPermissionTasks.vue"
import { mapState } from 'vuex'

export default {
  name: "caseConfigPermissions",
  components: {
    Loading,
    CaseConfigPermissionTasks,
    CaseConfigPermissionFeatures,
    CaseConfigPermissionData,
    CaseConfigPermissionFieldsets
  },
  props: { caseType: { type: Object, required: true } },
  data() {
    return {
      items: [
        {
          name: "Features",
          title: "Features",
          component: "CaseConfigPermissionFeatures"
        },
        {
          name: "Fieldsets",
          title: "Fieldsets",
          component: "CaseConfigPermissionFieldsets"
        },
        {
          name: "Data",
          title: "Data",
          component: "CaseConfigPermissionData"
        },
        {
          name: "Tasks",
          title: "Tasks",
          component: "CaseConfigPermissionTasks"
        }
      ]
    }
  },
  computed: {
    ...mapState({
      teams: state => state.teams.all
    }),
    permissionData() {
      if (this.caseType) {
        return {
          caseTypeId: this.caseType.id,
          permissions: this.caseType.permissions,
          resources: this.caseType.resources,
          accessTeams: this.caseType.teams,
          tasklists: this.caseType.tasklistTemplates
        }
      }
      return undefined
    }
  }
}
</script>

<style>
#permissions-fixed-content {
  margin: 0 -1px 0 0;
  width: 145px;
}

#permissions-legend ul {
  margin: 0 0 0;
  height: 233px;
  padding: 86px 0 0 0;
}

.letter {
  font-family: roboto;
  font-weight: 500;
  font-size: 20px;
}

#permissions-legend ul li {
  margin: 0;
  padding: 0;
  width: 100%;
  padding: 0px 20px 0px 0;
  list-style: none;
  height: 30px;
}

#permissions-users {
  margin: 2px 0 0 0;
  width: 100%;
  overflow: hidden;
  table-layout: fixed;
}

#permissions-users tr td {
  height: 40px;
  background-color: rgb(240, 240, 240);
  color: #1c1c2d;
  text-align: left;
  padding-left: 15px;
  padding-right: 10px;
}

#permissions-table {
  table-layout: fixed;
}

#permissions-table thead tr {
  height: 160px;
}

#permissions-table thead th.permission-label {
  min-width: 40px;
  min-height: 40px;
  background-color: rgb(240, 240, 240);
  color: #1c1c2d;
  text-align: left;
  text-indent: 10px;
  -webkit-transform: translatex(37px) skew(-25deg, 0deg);
  -ms-transform: translatex(37px) skew(-25deg, 0deg);
  transform: translatex(37px) skew(-25deg, 0deg);
}

#permissions-table thead th.permission-label div {
  position: relative;
  overflow: hidden;
  margin-right: -112px;
  margin-left: -49px;
  width: 160px;
  height: 40px;
  word-break: break-all;
  -webkit-transform: rotate(-90deg) skew(-20deg, 0deg);
  -ms-transform: rotate(-90deg) skew(-20deg, 0deg);
  transform: rotate(-90deg) skew(-20deg, 0deg);
  font-weight: 500;
}

#permissions-table tbody td.permission-check {
  border: 1px solid rgb(240, 240, 240) !important;
  width: 40px;
  height: 40px;
  text-align: center;
  cursor: pointer;
}

#permissions-table tbody td.permission-check:hover {
  background-color: rgb(240, 240, 240);
}

.sub-tabs-full-width .theme--light.v-tabs__bar {
  margin-left: -145px;
}

.tabs-shift-right {
  margin-right: -40px;
}

.sub-tabs-full-width .v-divider {
  margin-left: -145px;
  max-width: calc(100% + 145px);
  width: calc(100% + 145px);
}
</style>
